import store from '@/store'

function beforeEnter(to, from, next) {
    try {
        const { hasFeatureFlag } = store.getters

        const flags = to.meta.requiresFeatureFlags

        if (!Array.isArray(flags) || flags.length === 0) {
            next('/404')
            return
        }

        const hasAllFlags = flags.every((flag) => hasFeatureFlag(flag))

        if (!hasAllFlags) {
            next('/404')
            return
        }

        next()
    } catch (error) {
        store.dispatch('logout')
        next('login')
    }
}

export default beforeEnter
